import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function MechanismSection() {
  return <section className="py-12" data-id="element-216">
      <div className="max-w-2xl mx-auto editorial-text" data-id="element-217">
        <FadeIn data-id="element-218">
          <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-219">
            What’s Actually Causing Your Dental Problems Is Probably Not Where
            You Expect...
          </h2>
          <div className="rounded-xl overflow-hidden mb-6" data-id="element-220">
            <img src="https://cdn.magicpatterns.com/uploads/wTPKZD7bSgnrLxvwJVy964/hf_20260403_053932_20d36d49-4d9b-42c9-825b-b02e794a92e5_(1).png" alt="Bathroom vanity with dental products" className="w-full h-auto object-cover" data-id="element-221" />
          </div>
          <p data-id="element-222">
            The answer starts with something your dentist has never once
            mentioned in the chair.
          </p>
          <p data-id="element-223">You've probably heard about the gut microbiome by now.</p>
          <p data-id="element-224">
            The idea that trillions of bacteria live in your digestive system —
            and that when they're out of balance, everything goes wrong.
          </p>
          <p data-id="element-225">
            What almost nobody talks about is that your mouth has one too -
            called the oral microbiome - and right now, yours may be under
            attack.
          </p>
          <p className="font-[900]" data-id="element-226">
            And the reason it's under attack is sitting in your bathroom right
            now.
          </p>
          <p data-id="element-227">
            Your toothpaste. Your mouthwash. The very products you've been using
            every single day - thinking they're designed to "protect" you.
          </p>
          <p data-id="element-228">Now I don't want you to think these products are bad.</p>
          <p data-id="element-229">
            In fact, they are crucial — and I'm not here to tell you to stop
            brushing your teeth.
          </p>
          <p className="font-[700]" data-id="element-230">
            But there's a critical flaw in how these products work that nobody
            in the dental industry wants to talk about…
          </p>
          <p data-id="element-231">
            Even though they are designed to eliminate bacteria - they aren't
            designed to choose which kind of bacteria they eliminate…
          </p>
          <p data-id="element-232">
            In other words, they kill everything - and that includes both bad
            bacteria, and healthy bacteria…
          </p>
          <p data-id="element-233">And the reason why biofilm forms in the first place?...</p>
          <p data-id="element-234">
            Because your healthy bacteria is the only thing standing between
            your teeth and the Biofilm Crisis.
          </p>
          <p data-id="element-235">
            So when every antibacterial rinse, every fluoride treatment, every
            'deep clean' wipes out both — you're unknowingly leaving your
            mouth's entire defense system in ruins.
          </p>
          <p className="font-[700]" data-id="element-236">
            And when your teeth are vulnerable without any healthy bacteria to
            defend it…
          </p>
          <p data-id="element-237">
            That's when biofilm sees its opportunity to come in and quietly
            anchor itself on your enamel.
          </p>
          <p data-id="element-238">
            Like a cruise ship dropping a 30,000 pound anchor to prevent it from
            drifting.
          </p>
          <p data-id="element-239">That's quite how powerful and resilient biofilm really is…</p>
          <p data-id="element-240">
            In fact, studies show that once bacteria are inside a mature
            biofilm, they can be up to 1,000 times more resistant to
            antimicrobials than they are when floating freely.
          </p>
          <p data-id="element-241">
            And yet — every morning and every night, you're trying to fight a
            bulletproof fortress with the same toothbrush you've had since last
            spring.
          </p>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-242">
          <div className="mb-12 py-8 border-t border-b border-gray-200" data-id="element-243">
            <p className="font-[700]" data-id="element-244">
              Now you may be thinking - won't probiotics fix this problem?
            </p>
            <p data-id="element-245">
              Introduce healthy bacteria, and they take care of the biofilm
              causing all your problems.
            </p>
            <p data-id="element-246">
              Yes, probiotics are great in fact - but they're only half the
              answer…
            </p>
            <p data-id="element-247">Why? Because probiotics miss a critical step.</p>
            <h3 className="text-2xl font-bold text-gray-900 mt-8 mb-6" data-id="element-248">
              Why Probiotics Won't Work (Until You Fix This First)
            </h3>
            <div className="rounded-xl overflow-hidden mb-6" data-id="element-249">
              <img src="https://cdn.magicpatterns.com/uploads/4JZLiwLhsmcppTSRMdEAqG/hf_20260403_060845_1d1d38d4-d435-4cb4-9ba8-d94f3f4cfa27_(1).png" alt="Microscopic view of tooth enamel surface showing micro-cracks" className="w-full h-auto object-cover" data-id="element-250" />
            </div>
            <p data-id="element-251">
              You see, to put it simply, biofilm quite literally changes the
              composition of your teeth once it anchors onto your enamel.
            </p>
            <p data-id="element-252">
              As the acid it produces starts dissolving the actual mineral
              surface of your teeth…
            </p>
            <p data-id="element-253">Your enamel begins to break down and form micro-cracks.</p>
            <p data-id="element-254">
              And here's a critical insight — those cracks give the biofilm even
              better grip, like a self-reinforcing loop.
            </p>
            <p className="font-[700]" data-id="element-255">
              So even if someone restores their good bacteria perfectly, the
              structural damage is still there.
            </p>
            <p data-id="element-256">
              Because while healthy probiotics are the key to a healthy mouth,
              they don't fix the composition and structure of your enamel.
            </p>
            <p className="font-[700]" data-id="element-257">
              That's why probiotics alone will never work - and that's exactly
              why I recommend this one remarkable mineral to my patients.
            </p>
            <p data-id="element-258">One that researchers are now calling "liquid enamel"...</p>
            <p data-id="element-259">
              Because once you combine this incredible mineral with the correct
              bacteria strains…
            </p>
            <p data-id="element-260">
              What you get is the first complete solution to the Biofilm Crisis
              — one that doesn't just restore your mouth's defenses, but
              rebuilds the damage from the ground up.
            </p>
            <p data-id="element-261">And it's nothing like what you'd expect.</p>
            <p data-id="element-262">It's something far simpler than toothpaste or mouthwash.</p>
            <p data-id="element-263">
              Instead, it's a small chew that dissolves directly on the surface
              where all the damage happens.
            </p>
          </div>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-264">
          <p className="font-[700]" data-id="element-265">
            Now before I reveal exactly what this incredible solution is, and
            exactly why it works - there's a critical caveat you should be aware
            of.
          </p>
          <p data-id="element-266">
            This is in no way shape or form a "miracle" solution — and I want to
            be upfront about that.
          </p>
          <p data-id="element-267">
            If you have an active infection, a cracked tooth, or severe bone
            loss, you still need to see a dentist - because nothing replaces
            that.
          </p>
          <p data-id="element-268">
            What this is — is the missing piece I recommend every patient who
            comes in doing everything right and is still losing ground.
          </p>
          <p data-id="element-269">
            A way to restore what conventional dental care has been quietly
            destroying.
          </p>
          <p className="font-[700]" data-id="element-270">
            But it's not an overnight solution. This takes time. And real
            consistency.
          </p>
          <p data-id="element-271">
            But luckily consistency won't be a problem - because it's something
            you'll genuinely want to take.
          </p>
          <p data-id="element-272">
            Imagine — who wouldn't want to pop a great-tasting chew every
            morning, knowing that every second it's dissolving in your mouth,
            it's rebuilding the very foundation of your teeth and rearming the
            defense system that's been stripped away for years?
          </p>
          <p data-id="element-273">
            As an old-school dentist who has seen every trend and fad come and
            go through my office…
          </p>
          <p data-id="element-274">“Hey doc - have you heard of this? Does it actually help?”</p>
          <p data-id="element-275">
            And sure enough, it never does because it's built on absolutely no
            clinical evidence, and just marketing hype…
          </p>
          <p data-id="element-276">This one is different. The clinical evidence is real.</p>
          <p className="font-[700]" data-id="element-277">
            The one ingredient I'm going to reveal, along with the studies,
            genuinely even surprised me.
          </p>
          <p data-id="element-278">Which is why I recommend it to my own patients.</p>
          <p className="font-bold text-xl text-gray-900 mt-10" data-id="element-279">
            Here's what some of them have to say:
          </p>
        </FadeIn>
      </div>
    </section>;
}